import { getCurrencyLabel } from './currency';

/**
 * Display label for a model's KPI unit. 'euro' is the internal token for
 * "monetary" — the shown label uses the customer's actual currency
 * (e.g. 'Swedish Krona (kr)'); pass the currency code from useCurrency().
 */
export const formatKpiUnit = (
  unit: 'euro' | 'unit' | null | undefined,
  currencyCode = 'EUR',
): string => {
  if (!unit) {
    return '-';
  }
  return unit === 'euro' ? getCurrencyLabel(currencyCode) : 'Unit';
};
